import Joi from '@hapi/joi'

export const cropVarianceReportSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    estateID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Select Estate`,
        "any.required": `Estate required`
    }),
    divisionID: Joi.number().invalid(0).required().label("Division").messages({
        "any.invalid": `Select Division`,
        "any.required": `Division required`
    }),
    searchDate: Joi.string().invalid("").label("Search Date"),



}